<template>
  <div>
    <v-skeleton-loader
      v-if="isInitializing"
      class="m-auto"
      type="table"
      transition="scale-transition"
    />
    <TableRemote
      v-else
      :isSearchable="false"
      :headers="tableHeaders"
      :items="displayChangeEvents"
      :pagination="pagination"
      :loading="loading"
      :title="$t('logs.title')"
      @sendQueryParams="fetchQuery"
    >
      <template #SearchWithFilters>
        <SearchWithFilters
          :searchPlaceholder="$t('logs.searchBy')"
          :filters="filters"
          :filterName="filterName"
          :saveFilter="true"
          @onApplyFilters="handleApplyFilters"
          @onSearch="handleSearch"
        />
      </template>
    </TableRemote>
    <LoadingWidget
      :show="showLoadingWidget"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import LoadingWidget from '@/components/shared/widgets/LoadingWidget';
import TableRemote from '@/components/shared/content-views/VTableRemote';
import moment from 'moment';
import SearchWithFilters from '@/components/shared/SearchWithFilters.vue';
import filterMixin from '@/mixins/filterMixin';
import perpage from '@/constants/pagination';

export default {
    components: {
        LoadingWidget,
        TableRemote,
        SearchWithFilters,
    },
    mixins: [
        filterMixin,
    ],
    data() {
        return {
            startDateTime: [0, 0, 0],
            endDateTime: [23, 59, 59],
            loading: false,
            isInitializing: true,
            showLoadingWidget: false,
            changeEvents: [],
            pagination: {},
            filterName: 'logsFilter',
            queryParams: {
                perpage,
                startDate: '',
                endDate: '',
            },
            filters: [
                {
                    key: 'date',
                    label: 'laboratory.labels.date',
                    type: 'date',
                    value: [],
                    dateKeys: ['startDate', 'endDate'],
                    isRange: true,
                    datacy: 'LabReportDate',
                },
            ],
        };
    },
    computed: {
        ...mapGetters([
            'lang',
            'hasRole',
            'hasPermission',
        ]),
        tableHeaders() {
            const headers = [
                'date',
                'createdBy',
                'httpMethod',
                'url',
                'details',
                'sessionInfo',
                'clientInfo',
                'teamInfo',
            ].map(value => ({
                sortable: false,
                text: this.$t(`logs.labels.${value}`),
                value,
            }));
            return headers;
        },
        displayChangeEvents() {
            return this.changeEvents.map(event => ({
                httpMethod: event.httpMethod,
                details: event.details,
                date: this.$options.filters.formatDate(moment(event.date), 'L LT'),
                createdBy: event.createdBy,
                url: event.url,
                sessionInfo: event.sessionInfo,
                siteInfo: event.siteInfo,
                clientInfo: event.clientInfo,
                teamInfo: event.teamInfo,
            }));
        },
    },

    watch: {
        async lang() {
            await this.getChangeEvents();
        },
    },

    async created() {
        this.getFilterValues();
        this.isInitializing = false;
    },

    methods: {
        setDateTime(date, hours, minutes, seconds) {
            return date.hour(hours).minute(minutes)
                .second(seconds)
                .toISOString();
        },
        async getChangeEvents() {
            this.loading = true;
            const { data } = await await this.$rq.getChangeEvents(this.queryParams);
            this.changeEvents = data.changeEvents;
            this.pagination = data.pagination;
            this.loading = false;
        },

        async fetchQuery(queryParams) {
            this.queryParams = { ...this.queryParams, ...queryParams };
            await this.getChangeEvents();
        },

        handleSearch(search) {
            this.queryParams = {
                ...this.queryParams,
                search,
            };
            const cleanQueryParams = this.$utils.removeEmptyNullOrUndefined(this.queryParams, true);
            this.queryParams = cleanQueryParams;
            this.getChangeEvents();
        },
        handleApplyFilters(filterParams) {
            this.queryParams = {
                ...this.queryParams,
                ...filterParams,
            };
            if (filterParams?.reset) {
                this.getFilterValues(true);
            }
            const cleanQueryParams = this.$utils.removeEmptyNullOrUndefined(this.queryParams, true);
            this.queryParams = cleanQueryParams;

            // fix bug if you are in page higher of total pages
            this.queryParams.page = 1;
            if (this.queryParams.startDate) {
                this.queryParams.startDate = this.setDateTime(moment(this.queryParams.startDate).utc(), ...this.startDateTime);
            }

            if (this.queryParams.endDate) {
                this.queryParams.endDate = this.setDateTime(moment(this.queryParams.endDate).utc(), ...this.endDateTime);
            }


            this.getChangeEvents();
        },
    },
};
</script>

<style lang="scss" scoped>
</style>;
